export default __webpack_public_path__ + "9ce52d3f1557e0bd9a8b895cf5535ddd.png";